export default __webpack_public_path__ + "static/media/Max125_LateralDer.ed83fa47.webp";